import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'samples-shipping_details_modal-view';
/**
 * Fired when a logged-out user sees the shipping details modal after submitting their email
 */
export function trackSamplesShippingDetailsModalView() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
